import { Box, Stack, Container } from '@mui/material';
import Actions from './actions';
import type { FlowSlotDto } from '@/types/dtos/flows/response/flow.dto';
import type { FlowDetailMode } from './flow-detail.types';

export type { FlowDetailMode };

interface FlowBarProps {
  setShowFlowDetails: React.Dispatch<React.SetStateAction<FlowDetailMode | undefined>>;
  selectedSlot?: FlowSlotDto;
  showFlowDetails: FlowDetailMode | undefined;
}

export default function FlowBar({ setShowFlowDetails, selectedSlot, showFlowDetails }: FlowBarProps) {
  return (
    <Box
      sx={{
        bgcolor: 'background.topbar',
        borderBottom: 1,
        borderColor: 'divider',
        width: '100%',
        minHeight: '52px',
        mt: 0,
        position: 'fixed',
        top: { xs: '98px', md: '112px' }, // Offset for fixed headers: includes 48px top-bar plus additional header(s)/spacing (e.g., sub-header, toolbar)
        zIndex: 1000,
        left: 0,
        right: 0,
        overflow: 'visible',
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 1, sm: 2 }, py: 0 }}>
        <Stack
          direction="row"
          gap={1}
          alignItems="center"
          justifyContent="center"
          sx={{
            width: '100%',
            px: 1,
            pl: { sm: 2 },
            py: 0.75,
          }}
        >
          <Actions
            setShowFlowDetails={setShowFlowDetails}
            selectedSlot={selectedSlot}
            showFlowDetails={showFlowDetails}
          />
        </Stack>
      </Container>
    </Box>
  );
}
